import { instance } from './Axios';

export const getJobDepartments = async () => {
  const response = await instance.get<JobDepartment[]>('/job-departments');
  return response.data;
};
